export const POSITION_CLASSES = {
    topleft: 'leaflet-top leaflet-left',
    topright: 'leaflet-top leaflet-right',
    bottomleft: 'leaflet-bottom leaflet-left',
    bottomright: 'leaflet-bottom leaflet-right',
};

export const TOOLTIP_PLACEMENT = {
    topleft: 'right',
    topright: 'left',
    bottomleft: 'right',
    bottomright: 'left',
};
